import classNames from "classnames"

import {
  ContentTag,
  ImageTag,
  InPlaceEditingOff,
  connect,
  provideComponent
} from "scrivito"
import { Carousel } from "shared/ui/carousel/Carousel"

import {
  SlideWidgetInstance,
  isSlideWidgetInstance
} from "../SlideWidget/SlideWidgetClass"
import { SliderWidget } from "./SliderWidgetClass"
import "./styles/_slider-widget.scss"

provideComponent(SliderWidget, ({ widget }) => {
  const showControls = widget.get("autoplay") ? widget.get("controls") : true
  const intervalMs = Math.round((widget.get("autoplayInterval") ?? 5) * 1000)

  const items = widget
    .get("slides")
    .filter(isSlideWidgetInstance)
    .map(item => ({
      key: item.id(),
      title: "",
      content: (
        <div className={`bg-${item.get("backgroundColor")} || "transparent"`}>
          <ImageOrVideo widget={item} />
          <ContentTag content={item} attribute="content" />
        </div>
      )
    }))

  return (
    <Carousel
      className={classNames([
        "slider-widget",
        `${widget.get("margin") || "mb-4"}`,
        `${widget.get("marginTop") || "mt-0"}`
      ])}
      items={items}
      interval={widget.get("autoplay") ? intervalMs : null}
      hideControlsForMultiItems={!showControls}
      hideIndicatorForMultiItems={!showControls}
    />
  )
})

const ImageOrVideo = connect(({ widget }: { widget: SlideWidgetInstance }) => {
  const background = widget.get("background")
  if (!background) return null

  if (background.contentType().startsWith("video/")) {
    return (
      <video
        autoPlay
        className="img-background"
        key={background.contentUrl()}
        loop
        muted
        playsInline
        src={background.contentUrl()}
      />
    )
  }

  return (
    <InPlaceEditingOff>
      <ImageTag
        content={widget}
        attribute="background"
        alt="bg-img"
        className="img-background"
      />
    </InPlaceEditingOff>
  )
})
